export const defaultStyle = {
    wrapper: "bg-beige",
    content: "section-wrapper py-[60px]",
    container:
        "flex flex-col flex-col-reverse max-w-[704px] mx-auto lg:space-x-[20px] lg:max-w-none lg:flex-row xlg:space-x-[74px]",
}
